import { LIVING_SITUATIONS } from 'cpool-constants';
import { z } from 'zod';

import { Anschrift } from './Anschrift';
import { schemaInteger } from '../../utils/schema.utils';

export const Wohnsituation = z.object({
    anschrift: Anschrift.optional(),
    anzahlPersonenImHaushalt: schemaInteger.min(1).nullish().default(null),
    anzahlPkw: schemaInteger.min(0).nullish().default(null),
    gemeinsamerHaushalt: z.boolean().nullish().default(false),
    vorherigeAnschrift: Anschrift.optional(),
    wohnart: z.nativeEnum(LIVING_SITUATIONS).nullish().default(null),
    wohnflaeche: schemaInteger.nullish().default(null),
});

export type Schema_Wohnsituation = z.infer<typeof Wohnsituation>;

/* 
            wohnsituation: yup.object().shape({
                anschrift: anschriftSchema,
                anzahlPersonenImHaushalt: yup.number().integer().optional().nullable().default(null),
                gemeinsamerHaushalt: yup.boolean().optional().nullable().default(false),
                vorherigeAnschrift: anschriftSchema,
                wohnart: yup
                    .string()
                    .oneOf(['ZUR_MIETE', 'ZUR_UNTERMIETE', 'IM_EIGENEN_HAUS', 'BEI_DEN_ELTERN', null])
                    .optional()
                    .nullable()
                    .default(null),
                wohnflaeche: yup.number().integer().optional().nullable().default(null),
            }),
*/
